import { render, staticRenderFns } from "./NavigationBar.vue?vue&type=template&id=679af42a&scoped=true"
import script from "./NavigationBar.vue?vue&type=script&lang=js"
export * from "./NavigationBar.vue?vue&type=script&lang=js"
import style0 from "./NavigationBar.vue?vue&type=style&index=0&id=679af42a&prod&lang=scss"
import style1 from "./NavigationBar.vue?vue&type=style&index=1&id=679af42a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679af42a",
  null
  
)

export default component.exports